import { lazyLoad } from 'controller/utils/loadable';

export const NotificationDeliveryPage = lazyLoad(
    () => import('./NotificationDeliveryPage'),
    module => module.default,
);
